import { shareReplay } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { locationBroadcastService } from 'src/app/core/services/loaction-broadcast.service';
import { getSelectedStoreLocation } from 'src/app/shared/ui/locationstate/location.selectors';
import { AppState } from 'src/app/store/app.state';
import { environment } from 'src/environments/environment';
import {ApiService} from './../../../services/api';
import { TimezoneService } from 'src/app/services/timezone';
import { StoreLocationService } from 'src/app/core/services/storelocation.service';
@Component({
  selector: 'app-live-card',
  templateUrl: './live-card.component.html',
  styleUrls: ['./live-card.component.scss']
})
export class LiveCardComponent implements OnInit {
  maxWidth: any;

  constructor(
    private store: Store<AppState>,
    private cookieService: CookieService,
    private elRef: ElementRef,
    private http: HttpClient,
    private toastr: AlertService,
    private router: Router,
    private locService: locationBroadcastService,
    private ApiService: ApiService,
    private timezoneService: TimezoneService,
    private locationService: StoreLocationService,
  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
   }

  prevStartDate: any = this.timezoneService.get()().subtract(1, 'day').startOf('day');
  prevEndDate: any = this.timezoneService.get()().subtract(1, 'day').endOf('day');
  prevStartDateDisplay: any = this.prevStartDate.unix();
  prevEndDateDisplay: any = this.prevEndDate.unix();
  prevStartDateDisplayFormatted: any = this.timezoneService.get().unix(this.prevStartDateDisplay).format("MMM Do YY");
  prevEndDateDisplayFormatted: any = this.timezoneService.get().unix(this.prevEndDateDisplay).format("MMM Do YY");
  startDate: any = this.timezoneService.get()().startOf('day');
  endDate: any = this.timezoneService.get()().endOf('day');
  startDateDisplay: any = this.startDate.unix();
  endDateDisplay: any = this.endDate.unix();
  startDateDisplayFormatted: any = this.timezoneService.get().unix(this.startDateDisplay).format("MMM Do YY");
  endDateDisplayFormatted: any = this.timezoneService.get().unix(this.endDateDisplay).format("MMM Do YY");
  currency: any = this.cookieService.get('currency');
  storeIdFixed: any = this.cookieService.get('storeId');
  merchantId: any = this.cookieService.get("merchantId");
  GLOBALURL: String
  headerToken = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') }
  httpOptions1 = { headers: new HttpHeaders(this.headerToken) };
  cardData: any = {}
  currencyWidth: string = (this.currency === '$' || this.currency === '₱' || this.currency === '₹') ? '15px' : '40px';
  values : number []
  ngOnInit(): void {
    // this.locService.currentApprovalStageMessage.subscribe(storeId => {
    //   if(storeId) {
    //     this.changeStore(storeId)
    //   }
    // });
    this.getTotalReports();
    // console.log("LIVE_CURRENCY", this.cookieService.get('currency'))
    // this.store.select(getSelectedStoreLocation).subscribe((result) => {
    //   console.log("result",result)
    //   this.currency = result.currency
    // })
  }
  changeStore(event:any) {
    this.storeIdFixed = event
    this.getTotalReports()
  }
  loader: Boolean = false;
  async getTotalReports() {

    console.log("Asd",this.startDateDisplay)
    let params = {
      "reportName": "home_stats_report",
      "query": {
        "startDate": this.startDateDisplay,
        "endDate": this.endDateDisplay,
        "lastStartDate": this.prevStartDateDisplay,
        "lastEndDate": this.prevEndDateDisplay,
        "merchantId": this.merchantId,
        "storeId": this.storeIdFixed
      }
    }
    this.loader = true
    return this.http.post(this.GLOBALURL + '/reports/query', params, this.httpOptions1).pipe(shareReplay(1)).subscribe((response: any) => {
      //console.log(response)
      if (!response.error) {
        this.cardData = response.data
        this.loader = false

      } else {
        //this.toastr.error(response.message)
        this.loader = false
      }
    }, (error) => {
      this.loader = false
      //this.toastr.success(error.message);
      //jQuery(".allpageLoader").css("display","none");
    });
  }
  checkNegative(num:any) {
    if (Math.sign(num) === -1) {
      return true;
    }

    return false;
  }
  checkZeroInc(num: any) {
    if (Math.abs(num) === 0) {
      return true
    }
    return false
  }
  showPlusData(num) {
    if(num)
    return '+'+ num
    else
    return '+0'
  }
}
